import React, { FC } from 'react';
import { useResponsive } from '../contexts/ResponsiveContext';
import { Logo } from './Logo';

export const BrandingOverlay: FC = () => {
  const { isMobile, isTouch } = useResponsive();
  const isResponsiveMode = isTouch || isMobile;

  return (
    <>
      <div className="branding-overlay">
        <div className="branding-header">
          <Logo fontSize="1.1rem" letterSpacing="5px" showAlpha={true} />
        </div>
      </div>

      {isResponsiveMode && (
        <div 
          className="read-only-badge view-mode-badge" 
          title="This is a read only rendering of the application. The application is designed for laptops"
        >
          View Mode
        </div>
      )}
    </>
  );
};
